export default "__VITE_ASSET__BSIFZ2og__"